<template>
	<div class="right_body action_body"
  v-loading="isLoading"
  :element-loading-background="loadingBg"
  :element-loading-text="loadingTxt"
  >
		<span class="btn right_sub_btn save_btn" @click.stop="subSave" >提交数据</span>
    <div class="active_rumb"><span class="txt">采购退货</span></div>

		<div class="coll header_box">
			<h2 class="title"><span>抬头信息</span></h2>
			<v-head
			:fromData="fromData"
			:noFromData="noFromData"
			:suplierList="this.$store.state.cache.supplierList"
			:factoryList="this.$store.state.cache.factoryList"
			></v-head>
		</div>
		<div class="coll list_content">
			<h2 class="title"><span>数据明细</span></h2>
			<v-list
			:fromData="fromData"
      :noFromData="noFromData"
			ref="listChild"
			></v-list>
		</div>

	</div>
</template>

<script>
import {excelUpload,excelDownload} from 'api/excel.js'
import {suplierApi,matterTypeApi,factoryApi,fstockApi} from 'api/base.js';
import {purchasebackstock,purchase,purchaseType} from 'api/business.js'
import {saleOutStock} from 'api/stock.js'
import vHead from './components/add/head.vue';
import vList from './components/add/list.vue';
import { mapState,mapActions } from 'vuex';
export default {
	components:{
		vHead,
		vList
	},
    data() {
      return {
        id:'',
        isLoading:true,
        loadingBg:"rgba(255,255,255,1)",
        loadingTxt:"加载中",
        //需要提交的数据
        fromData:{
          details:[]
        },
        //不需要提交的数据
        noFromData:{},
      };
    },
	//设置校验规则
	vuerify:{
		'fromData.voucherDate':[
			'required',//必填项
			/* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
		]
	},
	computed: {
		errors () {
		  return this.$vuerify.$errors
		}
	},
	watch:{
		fromData:function(val,old){
			//console.log(val,old);
		}
	},
	created(){
		//请求初始数据
		this.getStartData();
	},
  methods: {
    ...mapActions('cache',['clearCache']),
    handleClick(tab, event) {
    },
	  //关闭弹窗
	  handleClose(){
	  },
	  //需要请求的初始数据
	  async getStartData(){
      //供应商
      if(!this.$store.state.cache.supplierList){
        let suplierList = await this.$post(suplierApi.list,this.$store.state.getAllPage);
        if(suplierList.status){
          suplierList.data.list.forEach((item)=>{
            item.value = item.supplierCode+'-' + item.supplierName;
          });
          this.$store.state.cache.supplierList = suplierList.data.list;
        }else{
          this.$store.state.cache.supplierList = null;
        }
      }

      //工厂列表
      if(!this.$store.state.cache.factoryList){
        let factoryList = await this.$post(factoryApi.list,this.$store.state.getAllPage);
        if(factoryList.status){
          factoryList.data.list.forEach((item)=>{
            item.value = item.factoryCode+'-' + item.factoryDesc;
          });
          this.$store.state.cache.factoryList = factoryList.data.list;
        }else{
          this.$store.state.cache.factoryList = null;
        }
      }
      this.isLoading = false;
	  },

	  //保存提交数据
	  async subSave(){
      let vm = this;
      if(!this.fromData.voucherDate){
        this.$message.error('请选择凭证日期');
        return false;
      }
      if(!this.fromData.postingDate){
        this.$message.error('请选择过账日期');
        return false;
      }
      if(!this.fromData.factoryId){
        this.$message.error('请选择正确的工厂');
        return false;
      }
      if(!this.fromData.inventoryId){
        this.$message.error('请选择正确的工厂库存地');
        return false;
      }
      if(!this.fromData.supplierId){
        this.$message.error('请选择正确的供应商');
        return false;
      }

      if(!this.$store.state.cache.selectedMatterStockList.length){
        this.$message.error('请选择物料明细');
        return false;
      }
      this.fromData.details = [];
      let isTrue = true;
      this.$store.state.cache.selectedMatterStockList.forEach((item) => {
        let quantity=parseInt(item.quantity)
        let quantityStr=quantity.toString()
        if(quantity<=0||quantityStr==='NaN'){
          vm.$message.error('退货数量必须大于0整数');
          isTrue = false;
          return false;
        }
        if(!item.quantity){
          vm.$message.error('请输入退货数量');
          isTrue = false;
          return false;
        }
      });
      if(!isTrue) return false;
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";
      this.fromData.details = this.$store.state.cache.selectedMatterStockList;
      this.fromData.voucherDate = this.$moment(this.fromData.voucherDate).format("YYYY-MM-DD");
      this.fromData.postingDate = this.$moment(this.fromData.postingDate).format("YYYY-MM-DD");
      let res = await this.$post(purchasebackstock.add,this.fromData);
      this.isLoading = false;
      if(res.status){
        this.$confirm('采购退货单号：'+res.data.materialVoucherCode+'创建成功,是否继续退货?', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '退出',
          type: 'success'
        }).then(() => {
          //凭证和过账默认今天
          let nowData = new Date();
          this.fromData = {
            'voucherDate':nowData,
            'postingDate':nowData,
            "details":[]
          };
          this.noFromData = {};
          //清除部分缓存数据
          vm.clearCache();
          vm.$router.push({name:'business-purchaseout-add'});
        }).catch(() => {
          vm.$router.push({name:'business-purchaseout-list'});
          //清除部分缓存数据
          vm.clearCache();
        });
      }else{
        this.$message.error(res.errorMsg);
      }
	 }
	},
}
</script>

<style lang="stylus" scoped>

</style>
